<template>
	<div id="footer">
	</div>
</template>

<script>
export default {
  name: 'FooterPC',
  props: {
	  
  },
  data() {
	return {
		
	}
  },
  methods: {
	  
  },
  
}
</script>

<style scoped>
</style>